import { Button, Layout } from 'antd';
import styled from 'styled-components';

import theme from '@theme';

export const StyledLayout = styled(Layout)`
  background-color: transparent;
`;

export const StyledContent = styled.div`
  display: flex;

  flex-direction: row;

  ${({ theme }) => theme.mediaQueries.TABLET} {
    flex-direction: column;
  }
`;

export const StyledButton = styled(Button)`
  background-color: ${theme.palette.primaryBrand};
  color: black;
  width: 100%;
  font-size: 18px;
  font-weight: 500;
  border-radius: 0;
  border: 0px;
  height: 80px;

  &:hover {
    background-color: white;
    color: black !important;
  }

  &:focus {
    background-color: black !important;
    color: white !important;
  }

  ${theme.mediaQueries.PHONE} {
    width: 100%;
  }
`;

export const SelectionWrapper = styled.div`
  display: inline-flex;
  background-color: #fff;
  border-right: 1px solid #232a2e;
  border-left: 1px solid #232a2e;
  position: relative;
  cursor: pointer;
  width: 100%;

  @media (max-width: ${theme.breakPoint.TABLET}) {
    border-right: 0px solid #000;
    border-left: 0px solid #000;
  }
  @media (max-width: ${theme.breakPoint.PHONE}) {
    border-right: 0px solid #000;
    border-left: 0px solid #000;
  }
`;

export const Content = styled.div`
  color: #434343;
  display: inline-flex;
  height: 80px;
  padding: 13px 22px;
  width: 125px;
  flex-direction: column;
`;

export const Label = styled.div`
  color: #000;
  font-size: 11px;
  font-weight: 400;
  display: inline-flex;
`;

export const Text = styled.div`
  color: #000;
  font-size: 17px;
  font-weight: 600;
  margin-top: 5px;
  display: inline-flex;
  white-space: nowrap;
`;

export const DateWrapper = styled.div`
  width: 150px;

  @media (max-width: ${theme.breakPoint.TABLET}) {
    width: 100%;
  }
`;
